import React, {Component} from "react";
import {connect} from "react-redux";
import {ReactSVG} from "react-svg";

import * as componentTypes from "../../constants/componentTypes";
import * as navigationActions from "../../actions/navigationActions";

import imgClose from "../../resources/img/svgicons/close.svg";
import imgWarning from "../../resources/img/svgicons/error.svg";
import imgError from "../../resources/img/svgicons/plus.svg";
import imgCheck from "../../resources/img/svgicons/check.svg";

class FlashMessage extends Component {
    handleDeleteNotificationClick = (event) => {
        this.props.dispatchDeleteFlashMessageAction(Number(event.currentTarget.dataset.id));
    };

    render() {
        if (this.props.type === componentTypes.FLASH_MESSAGE_SUCCESS) {
            return (
                <div className="flash-message">
                    <div className="flash-message-type success">
                        <ReactSVG src={imgCheck} className="type-img" alt="success" />
                    </div>
                    <div key={this.props.index} className="flash-message-content">
                        {this.props.text}
                    </div>
                    <div className="flash-message-close">
                        <ReactSVG
                            src={imgClose}
                            className="close-img"
                            alt="close"
                            data-id={this.props.index}
                            onClick={this.handleDeleteNotificationClick}
                        />
                    </div>
                </div>
            );
        }

        if (this.props.type === componentTypes.FLASH_MESSAGE_WARNING) {
            return (
                <div className="flash-message">
                    <div className="flash-message-type warning">
                        <ReactSVG src={imgWarning} className="type-img" alt="warning" />
                    </div>
                    <div key={this.props.index} className="flash-message-content">
                        {this.props.text}
                    </div>
                    <div className="flash-message-close">
                        <ReactSVG
                            src={imgClose}
                            className="close-img"
                            alt="close"
                            data-id={this.props.index}
                            onClick={this.handleDeleteNotificationClick}
                        />
                    </div>
                </div>
            );
        }

        if (this.props.type === componentTypes.FLASH_MESSAGE_ERROR) {
            return (
                <div className="flash-message">
                    <div className="flash-message-type error">
                        <ReactSVG src={imgError} className="type-img" alt="error" />
                    </div>
                    <div key={this.props.index} className="flash-message-content">
                        {this.props.text}
                    </div>
                    <div className="flash-message-close">
                        <ReactSVG
                            src={imgClose}
                            className="close-img"
                            alt="close"
                            data-id={this.props.index}
                            onClick={this.handleDeleteNotificationClick}
                        />
                    </div>
                </div>
            );
        }

        return (
            <div className="flash-message">
                <div className="flash-message-type info">
                    <ReactSVG src={imgWarning} className="type-img" alt="info" />
                </div>
                <div key={this.props.index} className="flash-message-content">
                    {this.props.text}
                </div>
                <div className="flash-message-close">
                    <ReactSVG
                        src={imgClose}
                        className="close-img"
                        alt="close"
                        data-id={this.props.index}
                        onClick={this.handleDeleteNotificationClick}
                    />
                </div>
            </div>
        );
    }
}

const mapStoreToProps = () => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchDeleteFlashMessageAction: (id) => {
            dispatch(navigationActions.deleteFlashMessage(id));
        }
    };
};

export default FlashMessage = connect(mapStoreToProps, mapDispatchToProps)(FlashMessage);
